var $ = require('jquery')

module.exports = function() {
  var ued = window.ued || {}
    , currentApkForDownload = ued.currentApkForDownload

  if (!currentApkForDownload) { return }

  location.href = currentApkForDownload
}
